module.exports = __webpack_public_path__ + "static/img/recall-share-popup.275aa8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/sixthAnniveRecall/recall/recall-share-popup.png
// module id = kgmH
// module chunks = 1